import React from 'react';

import { Flex } from '@rover/kibble/core';
import RoverBottomSheet from '@rover/kibble/official-patterns/BottomSheet';

export type Props = {
  isOpen: boolean;
  isFullHeight?: boolean;
  onRequestClose: (payload?: unknown) => void;
  style?: ReactModal.Styles;
  headerId?: string;
};

const BottomSheet: React.FC<{
  isOpen: boolean;
  onRequestClose: (payload?: unknown) => void;
  children: React.ReactNode;
}> = ({ children, isOpen, onRequestClose }): JSX.Element | null => {
  return isOpen ? (
    <RoverBottomSheet
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overflowY="auto"
      isDismissible={false}
    >
      <Flex width="100%" flexDirection="column" alignItems="center">
        {children}
      </Flex>
    </RoverBottomSheet>
  ) : null;
};

export default BottomSheet;
